<mat-toolbar>
    <navbar variant="horizontal-style-1"></navbar>
</mat-toolbar>
